// extracted by mini-css-extract-plugin
export default {"container":"ytUdbF","title":"eeiW2j","description":"KSSevh","link":"PH8oIJ","searchFadeIn":"LxbaG2"};